var map = {
	"./amazon.svg": 3156,
	"./apple.svg": 6100,
	"./cbs.svg": 4943,
	"./chase.svg": 6873,
	"./directv.svg": 333,
	"./ge.svg": 424,
	"./hyundai.svg": 9963,
	"./intuit.svg": 2609,
	"./kornferry.svg": 6314,
	"./nike.svg": 8117,
	"./oracle.svg": 6694,
	"./panavision.svg": 5820,
	"./southwest airlines.svg": 6311,
	"./submission.svg": 1186,
	"./technicolor.svg": 217,
	"./vance and hines.svg": 7977,
	"./verizon.svg": 24,
	"./volkswagen.svg": 7262,
	"./walmart.svg": 961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6539;